import { ovl } from "../../../../../../../../_ovlclient/src"
import type {
  SYSActions,
  SYSState,
} from "../../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../../_ovlclient/src/dataapi"
import { postRequest } from "../../../../../../../../_ovlclient/src/effects"
import { T } from "../../../../../../../../_ovlclient/src/global/globals"

import {
  FieldVal,
  FieldSetState,
} from "../../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { ScreenCurrent } from "../../../../../../../../_ovlclient/src/library/screenapi"
import { TableRefresh } from "../../../../../../../../_ovlclient/src/library/table/tableapi"

export const ResetDetailChanges = () => {
  let offering = ovl.getState().app.features.QUTOffering
  offering.detailsChanged = undefined
  offering.detailsMaterialChanged = false
  offering.cutPositionsChanged = false
  offering.detailsTransportChanged = false
  offering.detailsCostChanged = false
}

export const OfferingDetailsRefresh = async (
  state: SYSState,
  actions: SYSActions,
  context: any,
  force: boolean
) => {
  if (!state.app.global.QUT.tables.QUTOffering.data[context]) {
    return
  }
  let docEntry =
    state.app.global.QUT.tables.QUTOffering.data[context]["DocEntry"]
  await TableRefresh("QUTOfferingCosts", {
    forcedFilters: {
      staticFilter: {
        DocEntry: docEntry,
      },
    },
    preferCache: !force,
  })
  // get the itemcode lookups
  let res = await Data(
    "offering/offeringmaterialitemcodes",

    { ignoreSnack: true }
  )
  if (!res.data) {
    return
  }

  let lookupdata = res.data.data
  Object.keys(lookupdata).forEach((f) => {
    lookupdata[f].ItemName = T(lookupdata[f].ItemName)
    //lookupdata[f].Price = `~${lookupdata[f].Price.toString()}`
  })

  state.app.features.QUTOffering.lookups.U_ItemCode = res.data
  state.app.features.QUTOffering.lookups.U_ItemCode.sortFn = (a, b) =>
    a.Order - b.Order
  await TableRefresh("QUTOfferingMaterial", {
    forcedFilters: {
      staticFilter: {
        DocEntry: docEntry,
      },
    },
    preferCache: !force,
    suppressBusySnack: true,
  })

  await TableRefresh("QUTOfferingTransport", {
    forcedFilters: {
      staticFilter: {
        DocEntry: docEntry,
      },
    },
    preferCache: !force,
    suppressBusySnack: true,
  })

  if (force) {
    ResetDetailChanges()
  }
}
